import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@ant-design/icons';
import './OnboardingStepper.css';

/**
 * OnboardingStepper
 *
 * Shared 2-step progress indicator used across the Tendera onboarding flow.
 * Steps:
 *   [1] Account & security  (Registration / Hanko auth)
 *   [2] Company             (Basic info — the final step; submit completes onboarding)
 *
 * Props:
 *   currentStep: 1 | 2  (1-indexed)
 */
const OnboardingStepper = ({ currentStep }) => {
    const { t } = useTranslation();

    const items = [
        t('onboarding.stepper.account.title'),
        t('onboarding.stepper.company.title')
    ];

    const stateAt = (index) => {
        const stepNumber = index + 1;
        if (stepNumber < currentStep) return 'done';
        if (stepNumber === currentStep) return 'current';
        return 'upcoming';
    };

    return (
        <div
            className="tendera-stepper"
            role="list"
            aria-label={t('onboarding.stepper.ariaLabel', 'Onboarding progress')}
        >
            {items.map((title, i) => {
                const state = stateAt(i);
                const prevState = i > 0 ? stateAt(i - 1) : null;
                return (
                    <Fragment key={i}>
                        {i > 0 && (
                            <div
                                className={`tendera-stepper__line tendera-stepper__line--${prevState === 'done' ? 'done' : 'upcoming'}`}
                                aria-hidden="true"
                            />
                        )}
                        <div
                            className={`tendera-stepper__step tendera-stepper__step--${state}`}
                            role="listitem"
                            aria-current={state === 'current' ? 'step' : undefined}
                        >
                            <div className="tendera-stepper__slot">
                                <div className="tendera-stepper__circle">
                                    {state === 'done' ? <CheckOutlined /> : i + 1}
                                </div>
                            </div>
                            <div className="tendera-stepper__label">{title}</div>
                        </div>
                    </Fragment>
                );
            })}
        </div>
    );
};

export default OnboardingStepper;
